import React from "react";
import getCorePersonalStore from "../../../../../../../stores/core/core-personal-store";
import getUserAdvancedStore from "../../../../../../../stores/user-store/advanced-store";
import { TUserDetailsObject } from "../../../../../../../Types";
import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../../../core/et3-ui/ET3Margin";
import UserDetailRow from "./user-detail-row";
import { Link } from "react-router-dom";
import ET3DataLink from "../../../../../../../core/et3-shared-components/DataLink";
import { isPositiveNumber } from "et3-type-guards";
import { getPermissionIDRequired } from "../../../../../../../helpers/et3-has-permission";

const UserDetails = withLiteObserverAndTheme<TUserDetailsObject>((props) => {
  const { user, theme } = props;
  const { colors, getFontSize } = theme;
  const {
    id,
    username,
    gender,
    createdOn,
    loginCount,
    tempBanCount,
    warnCount
  } = user;
  const userPermissions = getCorePersonalStore().userPermissions.get();
  const hasUserMessagesPermission = isPositiveNumber(
    userPermissions.indexOf(getPermissionIDRequired("User-Messages")),
    true
  );

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        color={colors.all.transparent}
        fDirection="column"
        justifyContent="center"
        alignItems="flex-start"
        withShadow={false}
        width={650}
        height={420}
        style={{}}
        onClick={() => {}}
      >
        <UserDetailRow
          title="User ID"
          value={
            <Link
              to={`/users/advanced?id=${id}`}
              id="menu-item"
              rel="noopener"
              target="_blank"
              style={{
                textDecoration: "none",
                boxShadow: "none",
                backgroundColor: colors.all.transparent,
                borderBottom: `1px solid ${colors.all.blue}`
              }}
              aria-disabled={true}
            >
              {id}
            </Link>
          }
        />
        <UserDetailRow title="Username" value={username} />
        <UserDetailRow title="Gender" value={gender} />
        <UserDetailRow title="Created On" value={createdOn} />
        <UserDetailRow title="Login Count" value={loginCount} />
        <UserDetailRow
          value={
            <Link
              to={`/users/events?id=${id}`}
              rel="noopener"
              target="_blank"
              style={{
                textDecoration: "none",
                boxShadow: "none",
                color: colors.all.bondiBlue,
                fontSize: getFontSize(25)
              }}
            >
              {tempBanCount}
            </Link>
          }
          title="Temp Ban Count"
        />
        <UserDetailRow
          title="Warn Count"
          value={
            <Link
              to={`/users/events?id=${id}`}
              rel="noopener"
              target="_blank"
              style={{
                textDecoration: "none",
                boxShadow: "none",
                color: colors.all.bondiBlue,
                fontSize: getFontSize(25)
              }}
            >
              {warnCount}
            </Link>
          }
        />
        <Et3Margin top={20} right={0} bottom={0} left={0} />
        {hasUserMessagesPermission && (
          <ET3DataLink
            type={"text"}
            name={"USER_MESSAGES"}
            onPress={async () => {
              getUserAdvancedStore().goToUserMessagesNewTab(id);
              await getCorePersonalStore().insertAdminEvent({
                eventName: "GO_TO_MESSAGES",
                fromPage: "REPORTS",
                userID: id,
                extraData: {}
              });
            }}
          />
        )}
      </ET3Div>
    </React.Fragment>
  );
});
export default UserDetails;
